<template>
    <div class="table-responsive">
        <h3 style="margin-bottom: -35px;">My Career Bonus</h3>
        <div class="table-outer">
            <table class="table-style2">
                <thead>
                <tr class="business-qualifications-header-table">
                    <th v-for="(header, headerId) in tableHeaders"
                        :key="headerId" :class="{'active':  String(headerId) === careerLevel }">
                        <p>{{ header }}</p>
                    </th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(row, rowId) in tableRows"
                    :key="rowId"
                    class="row-items">
                    <td v-for="(cell, cellId) in row"
                        :class="{'active':  String(cellId) === careerLevel }">
                        <p>{{ cell }}</p>
                    </td>
                </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>

    export default {
        data () { 
            return {
                tableHeaders: {
                    career: 'Career level',
                    bronze: 'Bronze',
                    silver: 'Silver',
                    gold: 'Gold',
                    diamond: 'Diamond',
                    diamond_1: '1*Diamond',
                    diamond_2: '2*Diamond',
                    vip: 'Vip'
                },
                tableRows: {
                    1: {
                        career: 'Level 1',
                        bronze: '2%',
                        silver: '2%',
                        gold: '3%',
                        diamond: '4%',
                        diamond_1: '4%',
                        diamond_2: '4%',
                        vip: '4%',
                    },
                    2: {
                        career: 'Level 2',
                        bronze: '2%',
                        silver: '2%',
                        gold: '3%',
                        diamond: '4%',
                        diamond_1: '4%',
                        diamond_2: '4%',
                        vip: '4%',
                    },
                    3: {
                        career: 'Level 3',
                        bronze: '2%',
                        silver: '2%',
                        gold: '3%',
                        diamond: '3%',
                        diamond_1: '4%',
                        diamond_2: '4%',
                        vip: '4%',
                    },
                    4: {
                        career: 'Level 4',
                        bronze: '1%',
                        silver: '2%',
                        gold: '3%',
                        diamond: '3%',
                        diamond_1: '4%',
                        diamond_2: '4%',
                        vip: '4%',
                    },
                    5: {
                        career: 'Level 5',
                        bronze: '1%',
                        silver: '2%',
                        gold: '2%',
                        diamond: '3%',
                        diamond_1: '3%',
                        diamond_2: '3%',
                        vip: '4%',
                    },
                    6: {
                        career: 'Level 6',
                        bronze: '1%',
                        silver: '2%',
                        gold: '2%',
                        diamond: '3%',
                        diamond_1: '3%',
                        diamond_2: '3%',
                        vip: '3%',
                    },
                    7: {
                        career: 'Level 7',
                        bronze: '1%',
                        silver: '2%',
                        gold: '2%',
                        diamond: '3%',
                        diamond_1: '3%',
                        diamond_2: '3%',
                        vip: '3%',
                    },
                    8: {
                        career: 'Level 8',
                        bronze: '',
                        silver: '',
                        gold: '2%',
                        diamond: '3%',
                        diamond_1: '3%',
                        diamond_2: '3%',
                        vip: '3%',
                    },
                    9: {
                        career: 'Level 9',
                        bronze: '',
                        silver: '',
                        gold: '',
                        diamond: '3%',
                        diamond_1: '3%',
                        diamond_2: '3%',
                        vip: '3%',
                    },
                    10: {
                        career: 'Level 10',
                        bronze: '',
                        silver: '',
                        gold: '',
                        diamond: '',
                        diamond_1: '',
                        diamond_2: '3%',
                        vip: '3%',
                    },
                }
            }
        },
        computed: {
            careerLevel () {
                return this.$store.getters.user.careerLevel
            }
        }
    }
</script>

<style lang="scss" scoped>

    .table-style2{
        margin: 50px 0;
    }

    .business-qualifications-header-table{
        p{
            font-size: 13px;
        }
    }

    .dashboard-header{
        margin: 0;

        h2{
            margin: 0 0 30px 0;
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/layout/partials/section/content/business-qualifications/BusinessQualificationsTable.vue